import React from "react";
import JsonLdGeneric from "../JsonLdGeneric";

interface JsonLdProductProps {
  name: string;
  description: string;
  image: string;
  price: number;
  currency: string;
  url: string;
  hasStock?: boolean;
  brand?: string;
}

/**
 * Returns a component that adds a JSON-LD tag of type Product.
 * Used on wine and product detail pages for Google Shopping and search results.
 * @returns {Component}
 */
const JsonLdProduct = ({
  name,
  description,
  image,
  price,
  currency,
  url,
  hasStock = true,
  brand = "Good Pair Days",
}: JsonLdProductProps) => {
  const structuredProductJsonLdData = {
    "@context": "https://schema.org/",
    "@type": "Product",
    name,
    description,
    image,
    url,
    brand: {
      "@type": "Brand",
      name: brand,
    },
    offers: {
      "@type": "Offer",
      price: price.toFixed(2),
      priceCurrency: currency,
      availability: hasStock ? "https://schema.org/InStock" : "https://schema.org/OutOfStock",
      url,
    },
  };

  return <JsonLdGeneric jsonData={structuredProductJsonLdData} />;
};

export default JsonLdProduct;
